import { required } from 'vuelidate/lib/validators';

export default {
  name: { required },
  baseDate: { required },
  days: { required },
  hours: { required }
};
